import { colors } from '@/theme/colors';
import type { HeaderCellConfig } from '@/ui/table/table.types';
import { TemplateSortKey } from '../account-management.state';

export const templatesTableHeaders: HeaderCellConfig<TemplateSortKey>[] = [
  {
    columnKey: 'fileType',
    sortKey: TemplateSortKey.fileType,
    bgColor: colors.basics.white,
  },
  {
    columnKey: 'uploadedDate',
    sortKey: TemplateSortKey.createdDate,
    bgColor: colors.basics.white,
    align: 'left',
  },
];
